/**
 * 系统管理 用户管理
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home/Home' }">Home</el-breadcrumb-item>
      <el-breadcrumb-item>Account List</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="Search:">
        <el-select size="small" clearable v-model="formInline.account" placeholder="Account">
          <el-option v-for="(item,i) in accountListData" :key="i" :label="item.account" :value="item.account"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="">
        <el-input size="small" v-model="formInline.firstName" placeholder="First Name"></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input size="small" v-model="formInline.lastName" placeholder="Last Name"></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input size="small" v-model="formInline.tel" placeholder="Tel."></el-input>
      </el-form-item>
      <el-form-item v-show="loginUser === 'Super administrator'" label="">
        <el-select size="small" clearable v-model="formInline.authority" placeholder="Authority">
          <el-option v-for="(item,i) in roleListData" :key="i" :label="item.roleName" :value="item.roleName"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-show="loginUser === 'Super administrator'" label="">
        <el-select size="small" clearable v-model="formInline.belonging" placeholder="Belonging">
          <el-option v-for="(item,i) in beautyCenterListData" :key="i" :label="item.companyName" :value="item.companyName"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="">
        <el-select size="small" v-model="formInline.status" placeholder="Status">
          <el-option label="All" value=""></el-option>
          <el-option label="Disable" value="disable"></el-option>
          <el-option label="Enable" value="enable"></el-option>
          <el-option label="Online" value="online"></el-option>
          <el-option label="Offline" value="offline"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="Modification Time">
        <el-date-picker size="small" v-model="formInline.editTime" type="daterange" align="right" unlink-panels range-separator="To" start-placeholder="Start Date" end-placeholder="Ending Date" :picker-options="pickerOptions"></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">Search</el-button>
        <el-button v-show="loginUser === 'Super administrator'" size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">Add Account</el-button>
        <el-button v-show="loginUser === 'Super administrator'" size="small" type="primary" @click="handleunit()">Set the authority / beauty center</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :default-sort = "{prop: 'editTime', order: 'ascending'}" @selection-change="selectChange" :data="userData" highlight-current-row v-loading="loading" border element-loading-text="Loading..." style="width: 100%;">
      <el-table-column align="center" type="selection" width="50"></el-table-column>
      <el-table-column align="center" prop="firstName" label="First Name" width="120"></el-table-column>
      <el-table-column align="center" prop="lastName" label="Last Name" width="120"></el-table-column>
      <el-table-column align="center" prop="account" label="Account" width="120"></el-table-column>
      <el-table-column align="center" prop="tel" label="Tel." width="120"></el-table-column>
      <el-table-column align="center" prop="authority" label="Authority" min-width="120"></el-table-column>
      <el-table-column align="center" prop="belonging" label="Beauty center" min-width="120"></el-table-column>
      <el-table-column align="center" prop="status" label="status" min-width="120"></el-table-column>
      <el-table-column align="center" prop="editTime" label="Creation Time" min-width="130">
        <!-- <template slot-scope="scope">
          <div>{{scope.row.editTime|timestampToTime}}</div>
        </template> -->
      </el-table-column>
      <el-table-column label="Operation" fixed="right" min-width="300">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">Edit</el-button>
          <el-button size="mini" :type="scope.row.status === 'disable'?'info':'danger'" @click="deleteUser(scope.$index, scope.row)">{{scope.row.status === 'disable'?'Enable':'Disable'}}</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="40%" @click='closeDialog("edit")'>
      <el-form label-width="110px" ref="editForm" :model="editForm" :rules="rules">
        <el-form-item label="Account" prop="account">
          <el-input size="small" v-model="editForm.account" auto-complete="off" placeholder="Please enter your account"></el-input>
        </el-form-item>
        <el-form-item label="Password" prop="password">
          <el-input size="small" v-model="editForm.password" auto-complete="off" placeholder="Please enter your password"></el-input>
        </el-form-item>
        <el-form-item label="First Name" prop="firstName">
          <el-input size="small" v-model="editForm.firstName" auto-complete="off" placeholder="Please enter your first name"></el-input>
        </el-form-item>
        <el-form-item label="Last Name" prop="lastName">
          <el-input size="small" v-model="editForm.lastName" auto-complete="off" placeholder="Please enter your last name"></el-input>
        </el-form-item>
        <el-form-item label="Authority" prop="authority">
          <el-select size="small" clearable v-model="editForm.authority" placeholder="Please select" class="userRole">
            <el-option v-for="(item,i) in roleListData" :key="i" :label="item.roleName" :value="item.roleName"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Beauty center" prop="belonging">
          <el-select size="small" clearable v-model="editForm.belonging" placeholder="Please select" class="userRole">
            <el-option v-for="(item,i) in beautyCenterListData" :key="i" :label="item.companyName" :value="item.companyName"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Tel." prop="tel">
          <el-input size="small" v-model="editForm.tel" auto-complete="off" placeholder="Please enter your mobile phone number"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='closeDialog("edit")'>Cancel</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">Save</el-button>
      </div>
    </el-dialog>
    <!-- 数据权限 -->
    <el-dialog title="Data Permission" :visible.sync="dataAccessshow" width="30%" @click='closeDialog("perm")'>
      <!-- <el-tree ref="tree" default-expand-all="" :data="UserDept" :props="defaultProps" :default-checked-keys="checkmenu" node-key="id" show-checkbox>
      </el-tree> -->
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='closeDialog("perm")'>Cancel</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="menuPermSave">Save</el-button>
      </div>
    </el-dialog>
    <!-- 所属单位 -->
    <el-dialog title="Set the authority / beauty center" :visible.sync="unitAccessshow" width="30%" @click='closeDialog("unit")'>
      <!-- <el-tree ref="tree" default-expand-all="" :data="UserDept" :props="defaultProps" @check-change="handleClick" :default-checked-keys="checkmenu" node-key="id" show-checkbox check-strictly>
      </el-tree> -->
      <el-form label-width="110px" ref="editForm" :model="editForm" :rules="rules">
        <el-form-item label="Account:" border>
          <div class='serialnNmber-tag'>
            <el-tag v-for="(item,i) in selectdata" :key="i" closable type="info" size="small" :disable-transitions="false" @close="tagClose(i)"> {{item.account}} </el-tag>
          </div>
        </el-form-item>
        <el-form-item label="Authority:">
          <el-select size="small" clearable v-model="editForm.authority" placeholder="Authority">
            <el-option v-for="(item,i) in roleListData" :key="i" :label="item.roleName" :value="item.roleName"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Beauty center:">
          <el-select size="small" clearable v-model="editForm.belonging" placeholder="Beauty center">
            <el-option v-for="(item,i) in beautyCenterListData" :key="i" :label="item.companyName" :value="item.companyName"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='closeDialog("unit")'>Cancel</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="unitPermSave">Save</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// 导入请求方法
import {
  userList,
  userSave,
  userDelete,
  userPwd,
  userExpireToken,
  userFlashCache,
  userLock,
  roleList,
  deptList,
  UserDeptTree,
  UserDeptSave,
  UserDeptdeptTree,
  UserChangeDept,
  saveUserTotal,
  getbeautyCenter,
  updatebeautyCenter
} from '../../api/userMG'
import Pagination from '../../components/Pagination'
export default {
  data() {
    return {
      timer: null,
      loginUser: JSON.parse(localStorage.getItem('userdata'))._source.authority,
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      title: '',
      disableStatus: 'danger',
      disableText: 'Disable',
      editFormVisible: false, //控制编辑页面显示与隐藏
      dataAccessshow: false, //控制数据权限显示与隐藏
      unitAccessshow: false, //控制所属单位隐藏与显示
      // 编辑与添加
      editForm: {
        account: '',
        password: '',
        belonging: JSON.parse(localStorage.getItem('userdata'))._source.account !== 'admin' ? JSON.parse(localStorage.getItem('userdata'))._source.belonging : '',
        authority: JSON.parse(localStorage.getItem('userdata'))._source.account !== 'admin' ? JSON.parse(localStorage.getItem('userdata'))._source.belonging : '',
        firstName: '',
        lastName: '',
        status: '',
        editTime: '',
        tel: ''
      },
      pickerOptions: {
        shortcuts: [{
          text: 'Latest week',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Last month',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      // 部门参数
      unitparm: {
        userIds: '',
        deptId: '',
        deptName: ''
      },
      // 选择数据
      selectdata: [],
      // rules表单验证
      rules: {
        account: [
          { required: true, message: 'Please enter your account', trigger: 'blur' }
        ],
        password: [
          { required: true, message: 'Please enter your password', trigger: 'blur' }
        ],
        belonging: [{ required: true, message: 'Please select belonging', trigger: 'blur' }],
        authority: [
          { required: true, message: 'Please select authority', trigger: 'blur' }
        ],
        firstName: [
          { required: true, message: 'Please enter your First Name', trigger: 'blur' }
        ],
        lastName: [{ required: true, message: 'Please enter your Last Name', trigger: 'blur' }],
        tel: [{ required: true, message: 'Please enter your phone', trigger: 'blur' }]
      },
      // 删除用户
      seletedata: {
        ids: '',
        token: localStorage.getItem('userdata')
      },
      // 重置密码
      resetpsd: {
        userId: '',
        token: localStorage.getItem('logintoken')
      },
      // 用户下线
      offline: {
        token: localStorage.getItem('logintoken')
      },
      // 请求数据参数
      formInline: {
        dbName: 'user',
        page: 1,
        total: 10,
        account: '',
        password: '',
        belonging: JSON.parse(localStorage.getItem('userdata'))._source.account !== 'admin' ? JSON.parse(localStorage.getItem('userdata'))._source.belonging : '',
        authority: '',
        firstName: '',
        lastName: '',
        tel: '',
        status: '',
        editTime: ''
      },
      //用户数据
      userData: [],
      // 数据权限
      UserDept: [],
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      // 选中
      checkmenu: [],
      //参数role
      saveroleId: '',
      // 分页参数
      pageparm: {
        page: 1,
        size: 10,
        total: 10
      },
      roleFormInline: {
        page: 1,
        dbName: 'role',
        roleName: '',
        roleAuthorization: '',
        editTime: '',
        editUser: ''
      },
      beautyCenterFormInline: {
        dbName: 'beautycenter',
        fromName: 'user',
        page: 1,
        companyName: '',
        editUser: '',
        editTime: ''
      },
      accountFormInline: {
        dbName: 'user',
        page: 1,
        limit: 10,
        account: '',
        password: '',
        belonging: JSON.parse(localStorage.getItem('userdata'))._source.account !== 'admin' ? JSON.parse(localStorage.getItem('userdata'))._source.belonging : '',
        authority: JSON.parse(localStorage.getItem('userdata'))._source.account !== 'admin' ? JSON.parse(localStorage.getItem('userdata'))._source.belonging : '',
        firstName: '',
        lastName: '',
        tel: '',
        status: '',
        editTime: ''
      },
      roleListData : '',
      beautyCenterListData : '',
      accountListData: ''
    }
  },
  // 注册组件
  components: {
    Pagination
  },

  /**
   * 数据发生改变
   */
  watch: {},

  /**
   * 创建完毕
   */
  created() {
    if(this.loginUser !== 'Super administrator'){
      this.accountFormInline.belonging = JSON.parse(localStorage.getItem('userdata'))._source.belonging
      this.formInline.belonging = JSON.parse(localStorage.getItem('userdata'))._source.belonging
    }
    console.log(this.loginUser,'@@@@@@@@@@@@@@@@@@@@@@@@');
    // 获取账号
    userList(this.accountFormInline)
      .then(res => {
        this.loading = false
        if (res.code === 201) {
          this.accountListData = res.data
        }
    })
    // 获取权限
    roleList(this.roleFormInline)
      .then(res => {
        if (res.code === 201) {
          this.roleListData = res.data
        }
      })
    // 获取美容中心
    deptList(this.beautyCenterFormInline)
      .then(res => {
        if (res.code === 201) {
          this.beautyCenterListData = res.data
        }
      })
    this.getdata(this.formInline)
  },
  mounted(){
     this.timer = setInterval(() => {
         setTimeout(()=>{
          // 获取账号
          userList(this.accountFormInline)
            .then(res => {
              this.loading = false
              if (res.code === 201) {
                this.accountListData = res.data
              }
          })
          // 获取权限
          roleList(this.roleFormInline)
            .then(res => {
              if (res.code === 201) {
                this.roleListData = res.data
              }
            })
          // 获取美容中心
          deptList(this.beautyCenterFormInline)
            .then(res => {
              if (res.code === 201) {
                this.beautyCenterListData = res.data
              }
            })
          this.getdata(this.formInline)
         }, 0)
     }, 1000*30)
  },
  methods: {
    // 获取数据方法
    getdata(parameter) {
      this.loading = true
      userList(parameter)
        .then(res => {
          this.loading = false
          if (res.code === 201) {
            this.userData = res.data
            this.pageparm.page = res.page;
            this.pageparm.total = res.total;
          } else {
            this.userData = res.data
            // 分页赋值
            this.pageparm.currentPage = this.formInline.page
            this.pageparm.page = res.page
            this.pageparm.total = res.total
          }
      })
    },
    // 分页插件事件
    callFather(parm) {
      console.log(this.formInline);
      this.formInline.page = parm.currentPage
      this.getdata(this.formInline)
    },
    //搜索事件
    search() {
      this.getdata(this.formInline)
      console.log(this.formInline);
    },
    //显示编辑界面
    handleEdit: function(index, row) {
      this.editFormVisible = true
      if (row != undefined && row != 'undefined') {
        this.title = 'Edit';
        this.editForm.dbName = 'user';
        this.editForm.userId = row.id;
        this.editForm.account = row.account;
        this.editForm.password = row.password;
        this.editForm.belonging = row.belonging;
        this.editForm.authority = row.authority;
        this.editForm.firstName = row.firstName;
        this.editForm.lastName = row.lastName;
        this.editForm.tel = row.tel;
        this.editForm.status = row.status;
        this.editForm.editTime = row.editTime;
        this.editForm.type = 'edit'
      } else {
        var myDate = new Date();
        var hour = myDate.getHours();
        myDate.setHours(hour + 2)
        var time = myDate.toISOString()

        this.title = 'Add Account';
        this.editForm.dbName = 'user';
        this.editForm.account = '';
        this.editForm.password = '';
        this.editForm.belonging = '';
        this.editForm.authority = '';
        this.editForm.firstName = '';
        this.editForm.lastName = '';
        this.editForm.tel = '';
        this.editForm.status = 'offline';
        this.editForm.editTime = time;
        this.editForm.type = 'create'
      }
    },
    // 编辑、添加提交方法
    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          // 请求方法
          userSave(this.editForm)
            .then(res => {
              console.log(this.editForm);
              if (res.code === 201) {
                this.loading = true;
                var accountObj = {
                  dbName: 'user',
                  page: 1,
                  limit: 10,
                  account: '',
                  password: '',
                  belonging: this.editForm.belonging,
                  authority: '',
                  firstName: '',
                  lastName: '',
                  tel: '',
                  status: '',
                  editTime: ''
                }
                userList(accountObj)
                  .then(res => {
                    if(res.code === 201){
                      var beautyCenterObj = {
                        companyName : this.editForm.belonging
                      }
                      console.log(beautyCenterObj);
                      var total = res.total;
                      getbeautyCenter(beautyCenterObj)
                        .then(res => {
                          if(res.code === 201){
                            var updateObj = {
                              dbName : 'user',
                              updateId : res.selectId,
                              userTotal : total
                            }
                            updatebeautyCenter(updateObj)
                              .then(res => {
                                if(res.code === 201){
                                  this.$message({
                                    type: 'success',
                                    message: 'Data saved Successfully！'
                                  })
                                  this.loading = false;
                                  this.editFormVisible = false
                                  setTimeout(()=>{
                                    this.getdata(this.formInline)
                                  },800)
                                }
                              })
                          }
                        })
                    }
                  })
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('Save failed, please try again later！')
            })
        } else {
          return false
        }
      })
    },
    // 删除设备tag
    tagClose(tag) {
      console.log(tag);
      this.selectdata.splice(tag, 1);
    },
    // 显示部门设置
    handleunit: function(index, row) {
      this.unitAccessshow = true;
      this.editForm.belonging = '';
      this.editForm.authority = '';
      var arr = [];
      for(var i=0;i<this.selectdata.length;i++){
        arr.push(this.selectdata[i].id);
        this.editForm.userId = arr;
      }
      // let parms = 0
      // UserDeptdeptTree(parms)
      //   .then(res => {
      //     if (res.data.success) {
      //       this.UserDept = this.changeArr(res.data.data)
      //     } else {
      //       this.$message({
      //         type: 'info',
      //         message: res.msg
      //       })
      //     }
      //   })
      //   .catch(err => {
      //     this.loading = false
      //     this.$message.error('配置权限失败,请稍后再试！')
      //   })
    },
    handleClick(data, checked, node) {
      if (checked) {
        this.$refs.tree.setCheckedNodes([])
        this.$refs.tree.setCheckedNodes([data])
        this.unitparm.deptId = data.id
        this.unitparm.deptName = data.name
        //交叉点击节点
      } else {
      }
    },
    // 设置选中账号的权限
    unitPermSave() {
      console.log(this.editForm,'@@@@@@@@@@@@@@@@@@@');
      this.editForm.dbName = 'user';
      this.editForm.type = 'editBelonging';
      UserChangeDept(this.editForm)
        .then(res => {
          this.unitAccessshow = false
          if (res.code === 201) {
            this.$message({
              type: 'success',
              message: 'Authority / Belonging setting succeeded！'
            })
            setTimeout(()=>{
              this.loading = true;
              this.getdata(this.formInline);
            },800)
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('Authority / Belonging setting failed, please try again later！')
        })
    },
    // 选择复选框事件
    selectChange(val) {
      console.log(val);
      this.selectdata = val
    },
    // 关闭编辑、增加弹出框
    closeDialog(dialog) {
      if (dialog == 'edit') {
        this.editFormVisible = false
      } else if (dialog == 'perm') {
        this.dataAccessshow = false
      } else if (dialog == 'unit') {
        this.unitAccessshow = false
      }
    },
    // 禁用用户
    deleteUser(index, row) {
      this.$confirm('Sure you want to disable it?', 'Prompt', {
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        type: 'warning'
      })
        .then(() => {
          var userDeleteMsg = {
            dbName: 'user',
            type: 'deleteUser',
            userId: row.id,
            account: row.account,
            password: row.password,
            belonging: row.belonging,
            authority: row.authority,
            firstName: row.firstName,
            lastName: row.lastName,
            tel: row.tel,
            status: 'disable',
            editTime: row.editTime
          }
          if(row.status === 'disable'){
            userDeleteMsg.status = 'offline'
          }
          // 禁用
          userDelete(userDeleteMsg)
            .then(res => {
              if (res.code === 201) {
                var myDate = new Date();
                var hour = myDate.getHours();
                myDate.setHours(hour + 2)
                var time = myDate.toISOString()

                var obj = {
                  account : userDeleteMsg.account,
                  status : userDeleteMsg.status,
                  time : time
                }
                console.log(obj);
                saveUserTotal(obj)
                  .then(res => {
                    this.$message({
                      type: 'success',
                      message: 'User disabled!'
                    })
                    this.loading = true;
                    setTimeout(()=>{
                      this.getdata(this.formInline)
                    },800)
                  })
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('User disabling failed, please try again later！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: 'Has been cancelled！'
          })
        })
    },
    // 重置密码
    resetpwd(index, row) {
      this.resetpsd.userId = row.userId
      this.$confirm('确定要重置密码吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          userPwd(this.resetpsd)
            .then(res => {
              if (res.success) {
                this.$message({
                  type: 'success',
                  message: '重置密码成功！'
                })
                this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('重置密码失败，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '取消重置密码！'
          })
        })
    },
    // 数据权限
    dataAccess: function(index, row) {
      this.dataAccessshow = true
      this.saveroleId = row.userId
      UserDeptTree(row.userId)
        .then(res => {
          if (res.data.success) {
            this.checkmenu = this.changemenu(res.data.data)
            this.UserDept = this.changeArr(res.data.data)
          } else {
            this.$message({
              type: 'info',
              message: res.data.msg
            })
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('Failed to obtain permission. Please try again later！')
        })
    },
    //数据格式化
    changeArr(data) {
      var pos = {}
      var tree = []
      var i = 0
      while (data.length != 0) {
        if (data[i].pId == 0) {
          tree.push({
            id: data[i].id,
            name: data[i].name,
            pId: data[i].pId,
            open: data[i].open,
            checked: data[i].checked,
            children: []
          })
          pos[data[i].id] = [tree.length - 1]
          data.splice(i, 1)
          i--
        } else {
          var posArr = pos[data[i].pId]
          if (posArr != undefined) {
            var obj = tree[posArr[0]]
            for (var j = 1; j < posArr.length; j++) {
              obj = obj.children[posArr[j]]
            }

            obj.children.push({
              id: data[i].id,
              name: data[i].name,
              pId: data[i].pId,
              open: data[i].open,
              checked: data[i].checked,
              children: []
            })
            pos[data[i].id] = posArr.concat([obj.children.length - 1])
            data.splice(i, 1)
            i--
          }
        }
        i++
        if (i > data.length - 1) {
          i = 0
        }
      }
      return tree
    },
    // 选中菜单
    changemenu(arr) {
      let change = []
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].checked) {
          change.push(arr[i].id)
        }
      }
      return change
    },
    // 菜单权限-保存
    menuPermSave() {
      let parm = {
        userId: this.saveroleId,
        deptIds: ''
      }
      let node = this.$refs.tree.getCheckedNodes()
      let moduleIds = []
      if (node.length != 0) {
        for (let i = 0; i < node.length; i++) {
          moduleIds.push(node[i].id)
        }
        parm.deptIds = JSON.stringify(moduleIds)
      }
      UserDeptSave(parm)
        .then(res => {
          if (res.success) {
            this.$message({
              type: 'success',
              message: 'Permission saved successfully!'
            })
            this.dataAccessshow = false
            this.getdata(this.formInline)
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('Permission save failed, please try again later！')
        })
    },
    // 下线用户
    offlineUser(index, row) {
      this.$confirm('确定要让' + row.userName + '用户下线吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          userExpireToken(row.userName)
            .then(res => {
              if (res.success) {
                this.$message({
                  type: 'success',
                  message: '用户' + row.userName + '强制下线成功！'
                })
                this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('用户下线失败，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    },
    // 刷新缓存
    refreshCache(index, row) {
      userFlashCache(row.userName)
        .then(res => {
          if (res.success) {
            this.$message({
              type: 'success',
              message: '刷新成功！'
            })
            this.getdata(this.formInline)
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('刷新失败，请稍后再试！')
        })
    }
  },
  beforeDestroy(){
     clearInterval(this.timer);
     this.timer = null;
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
.serialnNmber-tag{
  width: 82%;
  min-height: 60px;
  border: 1px solid #DCDFE6;
  border-radius: 4px;
}
.el-tag.el-tag--info{
  margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/system/user.vue